import { render } from "./createRole.vue?vue&type=template&id=7f7c442f&scoped=true"
import script from "./createRole.vue?vue&type=script&lang=js"
export * from "./createRole.vue?vue&type=script&lang=js"

import "./createRole.vue?vue&type=style&index=0&id=7f7c442f&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7c442f"]])

export default __exports__